import React from 'react';

const SvgCustomerInsight = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M10 2a2 2 0 00-.64 3.893l.314 1.576A6.019 6.019 0 007.52 9.02l-1.523-.95a2 2 0 10-1.059 1.695l1.516.947a5.969 5.969 0 00.658 5.76l-1.595 1.595A2.001 2.001 0 003 20a2 2 0 004 0 2 2 0 00-.07-.516l1.597-1.597a5.964 5.964 0 006.5.285l1.075 1.205a2 2 0 101.49-1.336l-1.03-1.152a5.953 5.953 0 00.826-6.51l2.05-1.461a2 2 0 10-1.385-1.47L16.228 8.75A5.979 5.979 0 0012 7c-.127 0-.252.012-.377.02L11.32 5.5A2 2 0 0010 2zm2 7c1.133 0 2 .867 2 2s-.867 2-2 2-2-.867-2-2 .867-2 2-2zm0 5c1.639 0 3 .68 3 1.662V16H9v-.338C9 14.68 10.361 14 12 14z" />
  </svg>
);

export default SvgCustomerInsight;
